<template>
  <v-container fluid class="pa-1 pt-0">
    <v-row dense>
      <v-col cols="12">
       <master-products></master-products>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import MasterProducts from '@/components/Master/MasterProducts.vue'
</script>
<style scoped>
</style>
